import React, {useCallback, useRef, useState} from "react";
import {
  AButton,
  AIcon,
  APanel,
  APanelBody,
  APanelHeader,
  APanelTitle,
  ATextarea
} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {createInvestigation} from "store/features/investigationSlice";
import RunInvestigationPopover from "./RunInvestigationPopover";
import css from "./NewInvestigation.module.scss";

const NEW_INVESTIGATION_CHARACTERS_LIMIT = 2000;

const NewInvestigation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const anchorRef = useRef(null);

  const [infoPopoverOpen, setInfoPopoverOpen] = useState(false);
  const [inputStr, setInputStr] = useState("");

  const handleSubmitInvestigation = useCallback(
    () => dispatch(createInvestigation({query: inputStr, navigate})),
    [dispatch, inputStr, navigate]
  );

  return (
    <APanel data-testid={"NewInvestigationPanel-Panel"} className={css.panel}>
      <APanelHeader>
        <APanelTitle data-testid={"NewInvestigationPanel-Title"}>
          <span>{t("investigate.runInvestigation.title")}</span>
          <AButton
            medium
            tertiary
            icon
            className="pa-1 ml-1"
            onClick={() => setInfoPopoverOpen(!infoPopoverOpen)}
            data-testid={"NewInvestigationPanel-TitleInfoBtn"}
            ref={anchorRef}
            aria-haspopup="true">
            <AIcon>information</AIcon>
          </AButton>
        </APanelTitle>
      </APanelHeader>
      <APanelBody>
        <ATextarea
          data-testid={"NewInvestigationPanel-Textarea"}
          className={css.textArea}
          placeholder={t("investigate.runInvestigation.input.placeholder")}
          value={inputStr}
          onChange={(e) => setInputStr(e.target.value)}
          rows={10}
          maxLength={NEW_INVESTIGATION_CHARACTERS_LIMIT}
          hint={t("investigate.runInvestigation.input.lengthHint", {
            current: inputStr?.length ?? 0,
            limit: NEW_INVESTIGATION_CHARACTERS_LIMIT
          })}
          hideHintOnError={false}
          rules={[
            {
              test: (v) =>
                v.length < NEW_INVESTIGATION_CHARACTERS_LIMIT ||
                t(
                  "investigate.runInvestigation.input.lengthLimitReachedWarning",
                  {limit: NEW_INVESTIGATION_CHARACTERS_LIMIT}
                ),
              level: "info"
            }
          ]}
        />

        <div className="my-4">
          <AButton
            medium
            className="mr-2"
            data-testid={"NewInvestigationPanel-Button-investigate"}
            onClick={handleSubmitInvestigation}
            disabled={
              inputStr.length <= 0 ||
              inputStr.length > NEW_INVESTIGATION_CHARACTERS_LIMIT
            }>
            {t("investigate.runInvestigation.buttons.investigate")}
          </AButton>
        </div>
      </APanelBody>
      <RunInvestigationPopover
        open={infoPopoverOpen}
        setOpen={setInfoPopoverOpen}
        anchorRef={anchorRef}
      />
    </APanel>
  );
};

NewInvestigation.propTypes = {};

export default NewInvestigation;
